import classnames from 'classnames';
import React from 'react';
import { useField } from 'react-final-form';

import { InputLabelComponent } from '../../dsfr';

interface ErrorCodeComponentProps {
  className?: string;
}

export const ErrorCodeComponent: React.FC<ErrorCodeComponentProps> = React.memo(
  ({ className }: ErrorCodeComponentProps) => {
    const { input } = useField('errorCode');

    return (
      <div className={classnames('fr-input-group fr-input-group--readOnly', className)}>
        <InputLabelComponent id={input.name} texts={{ label: "Code d'erreur" }} />
        <input className="fr-input" id={input.name} {...input} readOnly />
      </div>
    );
  },
);

ErrorCodeComponent.displayName = 'ErrorCodeComponent';
